//
// ResponsiveLayout.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./LayoutElement";
import "./LayoutElementOrientation";
import "@sas-dvr/ltjs-commons/layout/ResponsiveLayoutOverflowType";
import "./LayoutElementWeights";

var ResponsiveLayout = createModule("BIRD::ResponsiveLayout", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::LayoutElement"], EventDispatcher, [
    ,
    {
        orientation: 4,
        overflow: 4,
        weights: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ResponsiveLayout;
